/** Treasure hunt texts. The riddles themselves stay in English (see content/treasure.ts). */
export const enTreasure = {
  treasure: {
    title: '🏴‍☠️ Treasure hunt',
    intro: 'Three treasures are hidden today. Read the English clues, follow the compass, and dig when it says “Right here!”.',
    clue: (n: number) => `Clue ${n}`,
    listen: '🔊 Listen',
    translate: '🌐 Hint in my language',
    follow: '🧭 Follow this clue',
    following: '🧭 Following',
    done: '✅ Found!',
    heat: ['🧊 Cold', '🌤️ Warm', '☀️ Warmer', '🔥 Hot!', '⛏️ Right here — dig!'],
    otherMap: '🧭 Not here — try another place',
    dig: '⛏️ Dig here',
    found: 'You found a treasure chest!',
    foundItem: (icon: string, name: string) => `Treasure! You found: ${icon} ${name}`,
    allFound: '🏆 All of today’s treasures found! Bonus +10⭐ +30🪙',
    albumTitle: 'Treasure album',
    album: {
      coin: 'Ancient coin', marble: 'Glass marble', shell: 'Spiral shell', robot: 'Tin robot', postcard: 'Old postcard', charm: 'Lucky charm',
      compass: 'Brass compass', feather: 'Golden feather', stamp: 'Rare stamp', crystal: 'Blue crystal', whistle: 'Silver whistle', medal: 'Hero medal',
    },
    hints: {
      fountain: 'Near the fountain (town or mall).',
      pond: 'At the edge of the park pond.',
      cherry: 'Under a cherry tree in the school courtyard.',
      busStop: 'Next to the bus stop on the main street.',
      slide: 'Beside the slide in the playground.',
      hay: 'Next to the hay at the riding stables.',
      tennis: 'At a corner of the tennis court.',
      track: 'At a corner of the running track.',
      mailbox: 'By the red mailbox in front of your home.',
      kiteTree: 'Under the big tree in the neighbourhood.',
      library: 'In the library, near the reading table.',
      piano: 'In the music room, beside the piano.',
      easel: 'In the art room, near the easel.',
      pool: 'At the pool, near the lifeguard’s chair.',
      store: 'Inside the corner store, between the shelves.',
      sofa: 'At home, near the living-room sofa.',
    },
  },
};
